<template>
  <v-app>
    <v-app-bar app color="grey lighten-5" flat>
      <!-- <v-app-bar-nav-icon color="grey darken-2"></v-app-bar-nav-icon> -->
      <router-link to="/" v-if="!$store.state.isLogin">
        <v-img
          alt="Mona Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/mona_logo.png')"
          transition="scale-transition"
          width="50"

        />
      </router-link>
      <router-link to="/dashboard" v-if="$store.state.isLogin">
        <v-img
          alt="Mona Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/mona_logo.png')"
          transition="scale-transition"
          width="50"

        />
      </router-link>
      <v-spacer></v-spacer>
      <div class="my-2 d-none d-md-block" v-if="!$store.state.isLogin">
        <v-btn text large to="/">Inicio</v-btn>
      </div>
      <div class="my-2 d-none d-md-block">
        <v-btn text large to="tracking">Mi Pedido</v-btn>
      </div>
      <div class="my-2 d-none d-md-block" v-if="!$store.state.isLogin">
        <v-btn text large  @click="goToSucursales">Sucursales</v-btn>
      </div>
      <div class="my-2 d-none d-md-block" v-if="!$store.state.isLogin">
        <v-btn 
          text 
          large 
          href="https://www.facebook.com/monadelastillero/menu/?ref=page_internal"
          target="_black"
        >Menú</v-btn>
      </div>
      <div class="my-2 d-none d-md-block" v-if="!$store.state.isLogin">
        <v-btn text large>Galería</v-btn>
      </div>
      <!-- <div class="my-2 d-none d-md-block" v-if="!$store.state.isLogin">
        <v-btn text large>Contacto</v-btn>
      </div> -->
      <div class="my-2" v-if="!$store.state.isLogin">
        <v-btn icon href="https://www.facebook.com/monadelastillero" target="_black">
          <v-icon>fab fa-facebook</v-icon>
        </v-btn>
      </div>
      <div class="my-2" v-if="!$store.state.isLogin">
        <v-btn text large to="/login">Login</v-btn>
      </div>
      <div class="my-2" v-if="$store.state.isLogin">
        <v-btn text large to="dashboard">Dashboard</v-btn>
      </div>
      <div class="my-2" v-if="$store.state.isLogin">
        <v-btn text large @click="logOut">Salir</v-btn>
      </div>
      <!-- <v-btn icon>
        <v-icon color="grey darken-1">mdi-open-in-new</v-icon>
      </v-btn> -->

      <v-menu 
        bottom 
        left
        
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            icon
            v-bind="attrs"
            v-on="on"
            class="hidden-sm-and-up"
          >
            <v-btn icon color="grey">
              <v-icon>fas fa-ellipsis-v</v-icon>
            </v-btn>
          </v-btn>
        </template>

        <v-list>
          <v-list-item-group>
            <v-list-item to="/" v-if="!$store.state.isLogin">
              <v-list-item-title>Inicio</v-list-item-title>
            </v-list-item>
            <v-list-item to="tracking">
              <v-list-item-title>Mi Pedido</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$store.state.isLogin">
              <v-list-item-title>Sucursales</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$store.state.isLogin"
              href="https://www.facebook.com/monadelastillero/menu/?ref=page_internal"
              target="_blank"
            >
              <v-list-item-title>Menú</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!$store.state.isLogin">
              <v-list-item-title>Galería</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item v-if="!$store.state.isLogin">
              <v-list-item-title>Contacto</v-list-item-title>
            </v-list-item> -->
        </v-list-item-group>
        </v-list>
      </v-menu>
      
    </v-app-bar>

    <v-main>
      <v-row class="black" v-if="!$store.state.isLogin">
        <v-spacer></v-spacer>
        <p class="subtitle-1 white--text px-5 mt-2">Centro <a class="tel-link" href="tel:+669-981-5610">669-981-5610</a> - Marina <a class="tel-link" href="tel:+669-916-0606">669-916-0606</a></p>
      </v-row>
      <router-view/>
    </v-main>
    <v-footer  
      app
    >
      <cookie-law buttonText="Entendido">
        <div slot="message">
          Utilizamos cookies para asegurar que damos la mejor experiencia al usuario en nuestro sitio web.
          <router-link to="aviso-de-privacidad">Más Información</router-link>
        </div>
      </cookie-law>
      <v-spacer></v-spacer>
      <div class="tel-link-black">
        Centro <a class="tel-link-black" href="tel:+669-981-5610">669-981-5610</a> - Marina <a class="tel-link-black" href="tel:+669-916-0606">669-916-0606</a> La Mona MX &copy; {{ new Date().getFullYear() }}
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'App',
  components: { 
    CookieLaw
  },
  data() {
    return {
      drawer: false,
    }
  },
  created() {
    const user = JSON.parse(localStorage.getItem('monaUser'))
    if(user !== null) {
      this.$store.state.user = user
      this.$store.state.token = localStorage.getItem('monaToken')
      this.$store.state.isLogin = true
      this.$router.push('dashboard')
      //console.log('in')
      //console.log('current user', user)
    }
    else {
      this.$store.state.user = null
      this.$store.state.isLogin = false
      //console.log('out')
      this.$router.push('/').catch(()=>{});
    }
  },
  methods: {
    logOut() {
      localStorage.removeItem('monaUser')
      this.$router.push('/')
      this.$store.state.isLogin = false
    },
    navigateTo(view) {
      this.$router.push(view)
    },
    goToSucursales() {
      
      console.log(this.$route.name)
      if(this.$route.name == 'Welcome') {
        this.$vuetify.goTo('#sucursales')
      }
      else {
        this.$router.push('/')
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || 'La Mona MX';
      }
    },
  }
}
</script>

<style>
  .fix-content {
    padding: 64px 0px 0px;
  }
  .tel-link {
    text-decoration: none;
    color: white !important;
  }
  .tel-link-black {
    text-decoration: none;
    color:grey !important;
  }
</style>
